<template>
  <div>
    <md-table-toolbar>
      <div class="md-toolbar-section-end" id="toolbar_show">
        <h1 class="md-title">用户管理</h1>
      </div>
    </md-table-toolbar>

    <div class="md-layout md-alignment-center-left">
      <div class="md-layout-item md-size-20">
        <md-field md-clearable md-inline>
          <label>输入手机号码按回车键搜索</label>
          <md-input v-model="accountSearched" @keyup.enter="getReward(accountSearched)"></md-input>
        </md-field>
      </div>
      <div id="v_code_allocate" class="md-layout-item">
        <md-button class="md-dense md-raised md-primary" @click="allocateVCode" v-if="needAllocate">
          分配视频码
        </md-button>
      </div>
    </div>

    <div class="md-layout md-alignment-left">
      <div class="md-layout-item">
        <div v-if="userInfo">已观看视频{{ userInfo.count }}次，code码为{{ userInfo.code }}</div>
      </div>
    </div>

    <p/>

    <div class="md-layout md-alignment-center">
      <div class="md-layout-item">
        <md-table v-model="devices" md-sort="last_check_time" md-sort-order="asc" md-card>
          <md-table-toolbar>
            <h1 class="md-title">激活设备</h1>
          </md-table-toolbar>

          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="ID" md-numeric>{{ item.id }}</md-table-cell>
            <md-table-cell md-label="序列号" md-sort-by="serial_number">{{ item.serial_number }}</md-table-cell>
            <md-table-cell md-label="激活时间" md-sort-by="active_time">{{
                new Date(item.active_time).toLocaleString()
              }}
            </md-table-cell>
            <md-table-cell md-label="上次访问时间" md-sort-by="last_check_time">{{
                new Date(item.last_check_time).toLocaleString()
              }}
            </md-table-cell>
            <md-table-cell md-label="状态" md-sort-by="freeze">{{ item.freeze ? '已冻结' : '正常' }}</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </div>

    <md-snackbar :md-active.sync="toast">{{ toastMsg }}</md-snackbar>

  </div>
</template>

<script>
export default {
  name: "UserManager",
  data: () => ({
    accountSearched: '',
    needAllocate: false,
    userInfo: null,
    devices: [],
    toast: false,
    toastMsg: "",
  }),
  watch: {
    accountSearched: function (newAccount) {
      if (!newAccount) {
        this.needAllocate = false;
        this.userInfo = null;
        this.devices = [];
      }
    }
  },
  methods: {
    getReward: function (accountSearched) {
      if (!accountSearched) {
        this.showErrorTips('请先输入手机号码');
        return
      }
      this.$http.get('/api/user/reward/' + accountSearched + "/").then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.userInfo = data.data;
                this.needAllocate = this.userInfo.code === null
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  case 1100:
                    this.showErrorTips('用户不存在（1100）');
                    break;
                  default:
                    this.showErrorTips('获取失败，服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status === 403) {
          localStorage.clear();
          this.$router.replace('/login')
        } else {
          this.showErrorTips('未知错误' + error);
        }
      })

      this.getActivatedDevices(accountSearched);
    },
    allocateVCode: function () {
      if (!this.accountSearched) {
        this.showErrorTips('请先输入手机号码');
        return
      }
      this.$http.put('/api/user/vcode/' + this.accountSearched + "/allocate/").then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.getReward(this.accountSearched)
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  case 1100:
                    this.showErrorTips('用户不存在（1100）');
                    break;
                  case 9000:
                    this.showErrorTips('没有未分配的视频码（9000）');
                    break;
                  default:
                    this.showErrorTips('分配失败，服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status === 403) {
          localStorage.clear();
          this.$router.replace('/login')
        } else {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    getActivatedDevices: function (accountSearched) {
      this.$http.get('/api/user/devices/' + accountSearched + "/").then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.devices = data.data.activatedDevices;
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  case 1100:
                    this.showErrorTips('用户不存在（1100）');
                    break;
                  default:
                    this.showErrorTips('获取失败，服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status === 403) {
          localStorage.clear();
          this.$router.replace('/login')
        } else {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    showTips: function (message) {
      this.toast = true
      this.toastMsg = message
    },
    showErrorTips: function (message) {
      this.toast = true
      this.toastMsg = message
    },
  }
}
</script>

<style scoped>
#v_code_allocate {
  text-align: left;
}

th {
  text-align: center;
}
</style>